import { Injectable, Pipe, PipeTransform, inject } from '@angular/core';
import { AppConfigService } from '../../providers/config.service';

@Pipe({
  name: 'watermarkUrl',
  standalone: true,
})
@Injectable({
  providedIn: 'root',
})
export class WatermarkUrlPipe implements PipeTransform {
  private config = inject(AppConfigService);

  transform(original_key: string): string {
    if (!original_key) return '';
    return `${this.config.assetsEndpoint}/images/${original_key}`;
  }
}
